import { TOPIC_NAMES } from 'crm-message-bus/types/MessageTopics';
export const OPEN_ATTACHMENTS_MODAL_HANDLER = {
  topic: TOPIC_NAMES.OPEN_ATTACHMENTS_MODAL,
  type: 'MODAL',
  componentLoader: () => import('../wrappers/OpenAttachmentsModal')
};